import 'owl.carousel';

jQuery( document ).ready(function($) {
    $( '.home-carousel' ).owlCarousel( {
		loop: true,
		items: 1,
		margin: 20,
		nav: true,
		dots: false,
		autoplay: true,
		autoplayTimeout: 6000,
		autoplaySpeed: 800,
		autoplayHoverPause: true,
		navText: [
			'<i class="fal fa-arrow-circle-left"></i><span class="sr">Left</span>',
			'<i class="fal fa-arrow-circle-right"></i><span class="sr">Next</span>'
		]
	});

	$('#menu-toggle').on('click', function(e){
		e.preventDefault();
		$('#menu').toggleClass('open');
		$('#menu-toggle').toggleClass('open');
		
	})

	$('#search-btn').on('click', function(e){
		e.preventDefault();
		$('#searchbox').toggleClass('open');
	})
});